import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';


const MAX_NAME = 40;

class JoinCustomView extends React.Component {

    constructor() {
        super();

        this.state = {
            name: "",
        }
    }

    handleChange(event) {

        this.setState({
            name: event.target.value.substring(0, MAX_NAME).replace("\n", "").trim(),
        });
    }

    clickJoin() {
        this.props.clickJoin(this.state.name || this.props.defaultName);
    }

    clickBack() {
        this.props.clickBack(this.state.name || this.props.defaultName);
    }  

	render() {
        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header/>

                <div class="middle" id="nickname">
                    <h3>
                        Nickname:<br/>
                        <input value={this.state.name} onChange={this.handleChange.bind(this)} 
                            autocomplete="off" type="text" id="name" placeholder={ this.props.defaultName }></input><br/><br/>
                        <div class="nameInst">
                            Make it cool and unique. Don't use your real name.
                        </div>
                        <button onClick={this.clickJoin.bind(this)} id="go">Join Game</button>
                    </h3>
                    <div class="tutorialPrivacyPopup">
                        By playing this game you agree to our <a href="https://traitors.sh/resources/privacy.html" target="_blank">Privacy Policy</a> and <a href="https://traitors.sh/resources/termsofservice.html" target="_blank">Terms of Service</a>
                    </div>
                </div>

                <Footer clickPrivacySettings={this.props.clickPrivacySettings}/>
            </div>
        );
	}
}

JoinCustomView.propTypes = {
  clickJoin: PropTypes.func,
  defaultName: PropTypes.string,
  clickBack: PropTypes.func,
};

export default JoinCustomView;